import { render, staticRenderFns } from "./PartnerManageStepperPDRView.vue?vue&type=template&id=4505311a&"
import script from "./PartnerManageStepperPDRView.vue?vue&type=script&lang=ts&"
export * from "./PartnerManageStepperPDRView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports